import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';
import { TEDParseDateTimeMode, ValueType } from '../FormatterTypes';
import {
  formatterBoolParamDef,
  formatterStrParamDef,
} from '../Utils/ParamUtils';
import { IInternalDateFormat } from '../Displayers/TEDCustomDateTimeDisplayer';
import { extractDateString } from '../Utils/TimeDateUtils';
import { booleanToString } from '../Utils/ValueUtils';

// Fungerar inte korrekt i alla fall. Behöver korrigering om den börjar användas.
export class TEDParseDateStr extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseDateStr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseDateStr;

  public mode() {
    return TEDParseDateTimeMode.pdmDateString;
  }

  asDateTime(
    value: ValueType,
    params: string,
    defaultParams: string
  ): IInternalDateFormat {
    const allowZero: boolean = formatterBoolParamDef(
      'AllowZero',
      params,
      this.defaultParams()
    );
    const valAsStr = valueToDateString(value, params, this.defaultParams());
    const ty = parseInt(valAsStr.slice(0, 4), 10);
    const tm = parseInt(valAsStr.slice(4, 6), 10);
    const td = parseInt(valAsStr.slice(6, 8), 10);
    const th = parseInt(valAsStr.slice(8, 10), 10);
    const tn = parseInt(valAsStr.slice(10, 12), 10);
    const ts = parseInt(valAsStr.slice(12, 14), 10);
    return {
      ty: ty || -1,
      tm: tm ? tm : tm === 0 && allowZero ? tm : -1,
      td: td ? td : td === 0 && allowZero ? td : -1,
      th: th ? th : th === 0 && allowZero ? th : -1,
      tn: tn ? tn : tn === 0 && allowZero ? tn : -1,
      ts: ts ? ts : ts === 0 && allowZero ? ts : -1,
      tms: -1,
    };
  }
}

const valueToDateString = (
  value: ValueType,
  params: string,
  defaultParams: string
): string => {
  let result = '';
  switch (typeof value) {
    case 'string':
      result = String(value);
      break;
    case 'number': {
      // assume it is a datetime double...
      const numVal = Number(value);
      //   const frac: number = numVal - Math.ceil(numVal);
      const dateSep: string = formatterStrParamDef(
        'DateSep',
        params,
        defaultParams,
        '-'
      );

      result = extractDateString(numVal, dateSep);

      break;
    }
    case 'boolean':
      result = booleanToString(Boolean(value));
  }

  return result;
};
